import React from 'react';
import _ from 'lodash';

const FirstStep = props => (
    <div className="fdvEquip-slides-item simpleSlide active" >
    <div className="card card-lg card-plain mb-4">

      {
        props.flagActionTab === 'dropdown'?(
          <div>
          {props.arrayAsignarBonos.filter(entry => !props.listaPedidosXProforma.filter(result => !(props.listaBonosXproformaEstados.indexOf(result.codFiveBono)>=0)).map(pedido => {return pedido.numPedidoVeh}).indexOf(entry)>0).length>0?(

            <div className="pillSelct-pills">
              <p className="card-lg-title">N° Pedidos</p>
            {
              props.arrayAsignarBonos.filter(entry => !props.listaPedidosXProforma.filter(result => !(props.listaBonosXproformaEstados.indexOf(result.codFiveBono)>=0)).map(pedido => {return pedido.numPedidoVeh}).indexOf(entry)>0)
              .map(element => (
              <label className="pill pill-cyan pillSelct-pills-item">{element}
              </label>
              ))
            }

              <div className="form-group " id="path">
                <button className="btn-largeBlock" fdvequipslide="next" onClick={props.nexBonos} >Bonos<i className="ion-ios-arrow-forward"></i></button>
              </div>

            </div>
          ):(
            <div>Se asignaron todos los bonos de proforma a este o a estos pedidos.</div>
          )}

            <p className="card-lg-title">N° Pedidos</p>
            <div className="pillSelct-pills">

            {
              props.arrayAsignarBonos.map(element => (
              <label className="pill pill-cyan pillSelct-pills-item">{element}
              </label>
              ))
            }
              <div className="form-group " id="path">
                <button className="btn-largeBlock" fdvequipslide="next" onClick={props.nexCortesia}>Cortesía<i className="ion-ios-arrow-forward"></i></button>
              </div>


            </div>
          </div>

        ):(
          <div>
            <div className="row">
              <div className="col-md-5">
              {props.pedidosToEdit.length>0?null:(
                <div className="dropdown dropdown-multi customToggle">
                  <div className="dropdown-control " data-toggle="dropdown">
                    <input className="dropdown-control-input" />
                    <label className="dropdown-control-fakelabel"><span></span><span className="dropdown-control-count"></span></label>
                    <div className="dropdown-control-icon"><i className="ion-arrow-down-b"></i></div>
                  </div>

                  <div className="dropdown-tooltip dropdown-menu "   >
                    <div className="dropdown-scroll">
                      <p></p>
                      <ul>

                      {
                        props.flagBonos==='AgregarBonos'?(

                        _.filter(props.pedidos, _.property(props.profroma))[0][props.profroma]
                        .filter(entry => !props.listaPedidosXProforma.filter(result => !(props.listaBonosXproforma.indexOf(result.codFiveBono)>=0)).map(pedido => {return pedido.numPedidoVeh}).indexOf(entry.numPedidoVeh)>=0)
                        .map(element => (
                          <li key={element.numPedidoVeh}>
                          <div className="checkbox">
                            <label>
                              <input type="checkbox" checked={props.arrayAsignarBonos.indexOf(element.numPedidoVeh)>=0} />
                              <div className="checkbox-skin" onClick={() =>  props.removeItems(element.numPedidoVeh,props.profroma)}></div>{element.numPedidoVeh}
                            </label>
                          </div>
                        </li>
                      ))):(
                        _.filter(props.pedidos, _.property(props.profroma))[0][props.profroma]
                        .map(element => (
                          <li key={element.numPedidoVeh}>
                          <div className="checkbox">
                            <label>
                              <input type="checkbox" checked={props.arrayAsignarBonos.indexOf(element.numPedidoVeh)>=0} />
                              <div className="checkbox-skin" onClick={() =>  props.removeItems(element.numPedidoVeh,props.profroma)}></div>{element.numPedidoVeh}
                            </label>
                          </div>
                        </li>
                      )))
                    }
                      </ul>
                    </div>

                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="pillSelct-pills">
            {props.pedidosToEdit.length>0?(props.pedidosToEdit.map(element => (
            <label className="pill pill-cyan pillSelct-pills-item">{element}</label>
            ))):(
              props.arrayAsignarBonos.map(element => (
              <label className="pill pill-cyan pillSelct-pills-item">{element}
                <button className="pillSelct-delete" onClick={() => props.removeCheckItems(element)}><i className="icon ion-close pill-close"></i></button>
              </label>
              ))
            )}
          </div>
      </div>
        )
      }

    </div>
    {
      props.flagActionTab === 'dropdown'?(
      <div className="form-group " id="path">
{/*
        <button className="btn-largeBlock" fdvequipslide="next" onClick={props.nexBonos} >Bonos<i className="ion-ios-arrow-forward"></i></button>
        <button className="btn-largeBlock" fdvequipslide="next" onClick={props.nexCortesia}>Cortesía<i className="ion-ios-arrow-forward"></i></button>
*/}
      </div>
      ):(
      <div class="modal-actions js-open" id="bonoAct">
        <button class="btn btn-primary pull-right" fdvequipslide="next" show="#bonoSec,#bonoTl" hide="#cortesSec,#cortesTL" onClick={props.nextStep}
        disabled={props.pedidosToEdit.length===0?props.arrayAsignarBonos.length>0? false:true:false}
        >Siguiente
        </button>
      </div>
      )
    }
  </div>
  );

  export default FirstStep;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/Bonos/AgregarBonos/FirstStep.js